module.exports = __webpack_public_path__ + "img/icon_ofen.599b37df.png";